<!-- <div class="editor-container"> -->
  <label class="label general-text-6 mb-2">{{label}}</label>
  <div class="editor-box">
    <quill-editor [(ngModel)]="text" [modules]="editorConfig" [placeholder]="placeholder"
    (ngModelChange)="onContentChanged($event)"></quill-editor>
  </div>
<!-- </div> -->


